/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/newConnection/NewConnectionPanel.Props" />
import { IDisableOAuthProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/DisableOAuth.props";
import { IBasePanelContentProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/BasePanelContent.Props";
import { IShowPanelProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/ShowPanel.props";

export interface INewConnectionPanelProps extends IBasePanelContentProps, IShowPanelProps, IDisableOAuthProps {}
